// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/ticketservice/tickets.actions.go

import { type Scope } from "~/hooks/useScope";
import { CREATE_TICKET_FOR_CASE } from "./action";

export function canCreateTicketForCase(scope: Scope): boolean {
  return scope.iamActions.includes(CREATE_TICKET_FOR_CASE);
}
